import React from "react";
import styles from "./Contactus.module.css";
export default function Map() {
  return (
    <div className={styles.mapContainer}>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d110565.41515745666!2d29.8260155!3d31.2000924!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14f5c3e6986c0e6d%3A0x7b3a8fcb07b2c03a!2sAlexandria%2C%20Egypt!5e0!3m2!1sen!2seg!4v1696431999999!5m2!1sen!2seg"
        height="500"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}
